<script lang="ts">
  import RadioButton from '$components/ui/radio-button.svelte';

  import type {
    GetProductQuery,
    ProductCardFragment,
    QuickAddToCartFragment
  } from '$gql/storefront/operations';

  export let product:
    | NonNullable<GetProductQuery['product']>
    | ProductCardFragment
    | QuickAddToCartFragment;
  export let selectedPlanId: string | undefined;
  export let variant: 'ghost' | undefined = undefined;

  const sellingPlans =
    product.sellingPlanGroups.edges.length > 0
      ? product.sellingPlanGroups.edges[0]?.node.sellingPlans.edges
          .map((e) => e.node)
          .map((plan) => ({
            id: plan.id,
            name: plan.name || ''
          }))
      : [];

  const sellingPlanName =
    product.sellingPlanGroups.edges.length > 0 ? product.sellingPlanGroups.edges[0]?.node.name : '';
</script>

<div class="mb-4">
  <div class="flex gap-2 mb-2 text-sm font-medium text-primary/60">
    <p>{sellingPlanName}</p>
  </div>

  <form class="flex flex-wrap gap-2">
    {#each sellingPlans as plan}
      <RadioButton
        value={plan.id}
        {variant}
        label={plan.name}
        id={plan.id}
        name="plan"
        bind:group={selectedPlanId}
      />
    {/each}
  </form>
</div>
